<script>
    export let sections;
    export let currentSection;
    export let scrollToSection;
</script>

<style>
    .navbar {
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        background: rgba(255, 255, 255, 0.8);
        padding: 10px 20px;
        border-radius: 25px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        z-index: 10;
    }

    .navbar button {
        background: none;
        border: none;
        padding: 10px;
        margin: 0 10px;
        font-size: 1rem;
        cursor: pointer;
        color: gray;
        transition: transform 0.3s ease;
    }

    .navbar button.active {
        font-weight: bold;
        color: black;
    }

    .navbar button:hover {
        transform: scale(1.1);
    }

    @media (max-width: 768px) {
        .navbar {
            display: none;
        }
    }
</style>

<div class="navbar">
    {#each sections as section, i}
        <button on:click={() => scrollToSection(i)} class="{currentSection === i ? 'active' : ''}">
            {section.title}
        </button>
    {/each}
</div>
